var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmptyUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_2340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9983 35.9965C28.8339 35.9965 35.9965 28.8339 35.9965 19.9983C35.9965 11.1627 28.8339 4 19.9983 4C11.1627 4 4 11.1627 4 19.9983C4 28.8339 11.1627 35.9965 19.9983 35.9965Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6388 26.1575H25.3612C28.3313 26.1575 30.9119 27.886 32.1674 30.3831C34.5532 27.5869 36 23.9629 36 20.0016C36 11.1643 28.8356 4.00336 20.0017 4.00336C11.1679 4.00336 4 11.1608 4 19.9981C4 23.9629 5.44332 27.5869 7.83263 30.3796C9.08814 27.8825 11.6687 26.154 14.6388 26.154V26.1575ZM19.9983 9.01846C24.0361 9.01846 27.3122 12.3955 27.3122 16.562C27.3122 20.7285 24.0396 24.1055 19.9983 24.1055C15.957 24.1055 12.6843 20.7285 12.6843 16.562C12.6843 12.3955 15.957 9.01846 19.9983 9.01846Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15V16.141",
    stroke: "#F3F4F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 15V16.141",
    stroke: "#F3F4F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 19C23 19.5521 21.1313 20 20.0606 20H19.9394C18.8687 20 17 19.5521 17 19",
    stroke: "#F3F4F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_2340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyUser);
export default __webpack_public_path__ + "static/media/icon-empty-user.a0c8f642e13303239c07cb82ac85c297.svg";
export { ForwardRef as ReactComponent };